import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { DefaultSpinner } from '../ui/Spinner';
import { SERVER_HOST } from './auth/Configs';
import { expireSession } from './auth/sessionExpiry';
import { Apps_User_Profile } from './store/Profile/Actions';
import '../../assets/css/customAdmin.css';

const Apps = () => {
  const session = useSelector((state) => state.sessionAuth);
  const dispatch = useDispatch();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!session.isAuthenticated || !session.token || session.token === 'expired') {
      setChecking(false);
      return undefined;
    }

    let active = true;
    setChecking(true);
    const headers = { Authorization: `Bearer ${session.token}` };
    axios.get(`${SERVER_HOST}/user/token_t`, { headers })
      .then(() => axios.get(`${SERVER_HOST}/user/${session.userId}/${session.sessionId}`, { headers }))
      .then((response) => {
        if (active) dispatch(Apps_User_Profile(response.data.profile));
      })
      .catch((error) => {
        if (active && error.response?.status === 401) expireSession();
      })
      .finally(() => {
        if (active) setChecking(false);
      });

    return () => { active = false; };
  }, [dispatch, session.isAuthenticated, session.sessionId, session.token, session.userId]);

  if (!session.isAuthenticated || !session.token || session.token === 'expired') {
    return <Navigate to="/login" replace />;
  }
  return checking ? DefaultSpinner('Chargement...') : <Outlet />;
};

export default Apps;
